import packageJson from '../../package.json';
import { AppConfig } from 'model/index';
var app: AppConfig;
globalThis.app = {
    tokenName: 'token-v1',
    baseDomain: `${window.location.origin}`,
    baseUrl: `${window.location.origin}/api`,
    version: packageJson.version,
};
globalThis.showId = 0;
// Freeze so these can only be defined in this file.
Object.freeze(globalThis.app);
// globalThis.app = {
//     tokenName: 'token-v1',
//     baseDomain:
//         process.env.NODE_ENV === 'development'
//             ? 'https://orderlocalapi.tradeshoweasy.com/api'
//             : `${window.location.origin}`,
//     baseUrl:
//         process.env.NODE_ENV === 'development'
//             ? 'https://orderlocalapi.tradeshoweasy.com/api'
//             : `${window.location.origin}/api`,
//     version: packageJson.version,
// };